(function () {
  var MODEL_RE = /^[A-Za-z0-9_-]+$/;
  var PDFJS_BASE = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@3.11.174/';
  var PDFJS_SCRIPT = PDFJS_BASE + 'build/pdf.min.js';
  var PDFJS_WORKER = PDFJS_BASE + 'build/pdf.worker.min.js';
  var PDFJS_CMAP = PDFJS_BASE + 'cmaps/';
  var PDFJS_FONTS = PDFJS_BASE + 'standard_fonts/';
  var MAX_CANVAS = 4096;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function isAndroid() {
    return /Android/i.test(navigator.userAgent || '');
  }

  function needsPdfJs() {
    var ua = navigator.userAgent || '';
    if (/Android|iPhone|iPad|iPod|Mobile|MicroMessenger|WebView|HarmonyOS/i.test(ua)) return true;
    if (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1) return true;
    if ((navigator.maxTouchPoints || 0) > 0 && Math.min(window.innerWidth, window.innerHeight) <= 900) {
      return true;
    }
    return false;
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      if (window.pdfjsLib) return resolve();
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function setupWorker(pdfjsLib) {
    return fetch(PDFJS_WORKER)
      .then(function (res) {
        if (!res.ok) throw new Error('worker fetch failed');
        return res.text();
      })
      .then(function (text) {
        var blob = new Blob([text], { type: 'application/javascript' });
        pdfjsLib.GlobalWorkerOptions.workerSrc = URL.createObjectURL(blob);
      })
      .catch(function () {
        pdfjsLib.GlobalWorkerOptions.workerSrc = PDFJS_WORKER;
      });
  }

  ready(function () {
    var root = document.getElementById('qr-pdf-root');
    if (!root) return;

    var statusEl = document.getElementById('qr-pdf-status');
    var frameEl = document.getElementById('qr-pdf-frame');
    var pagesEl = document.getElementById('qr-pdf-pages');
    var filesBase = (root.getAttribute('data-files-base') || '').replace(/\/?$/, '/');
    var model = (new URLSearchParams(window.location.search).get('m') || '').trim();

    function fail(msg) {
      statusEl.hidden = false;
      statusEl.textContent = msg;
      statusEl.classList.add('is-error');
      if (frameEl) frameEl.hidden = true;
      if (pagesEl) pagesEl.hidden = true;
    }

    if (!model) return fail(root.getAttribute('data-msg-missing'));
    if (!MODEL_RE.test(model)) return fail(root.getAttribute('data-msg-invalid'));
    if (!filesBase || filesBase === '/') return fail(root.getAttribute('data-msg-notfound'));

    var pdfUrl = filesBase + encodeURIComponent(model) + '.pdf';

    if (!needsPdfJs()) {
      document.documentElement.classList.add('qr-pdf-native');
      document.body.classList.add('qr-pdf-native');
      statusEl.hidden = true;
      frameEl.hidden = false;
      frameEl.src = pdfUrl;
      return;
    }

    if (frameEl) frameEl.hidden = true;

    loadScript(PDFJS_SCRIPT)
      .then(function () {
        return setupWorker(window.pdfjsLib);
      })
      .then(function () {
        return renderWithPdfJs(pdfUrl, pagesEl, statusEl);
      })
      .catch(function () {
        fail(root.getAttribute('data-msg-notfound'));
      });
  });

  function renderWithPdfJs(pdfUrl, pagesEl, statusEl) {
    var pdfjsLib = window.pdfjsLib;

    return pdfjsLib
      .getDocument({
        url: pdfUrl,
        cMapUrl: PDFJS_CMAP,
        cMapPacked: true,
        standardFontDataUrl: PDFJS_FONTS,
        disableAutoFetch: false,
        disableStream: false,
        disableFontFace: false,
        useSystemFonts: true,
        withCredentials: false
      })
      .promise.then(function (pdf) {
        statusEl.hidden = true;
        pagesEl.hidden = false;
        var width = Math.min(
          900,
          Math.max(280, (window.innerWidth || document.documentElement.clientWidth || 375) - 16)
        );
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (!entry.isIntersecting) return;
              var slot = entry.target;
              observer.unobserve(slot);
              renderPage(pdf, Number(slot.getAttribute('data-page')), slot, width);
            });
          },
          { rootMargin: '320px 0px', threshold: 0.01 }
        );

        var eager = isAndroid() ? 3 : 2;
        for (var i = 1; i <= pdf.numPages; i += 1) {
          var slot = document.createElement('div');
          slot.className = 'qr-pdf__slot';
          slot.setAttribute('data-page', String(i));
          pagesEl.appendChild(slot);
          if (i <= eager) {
            renderPage(pdf, i, slot, width);
          } else {
            observer.observe(slot);
          }
        }
      });
  }

  function renderPage(pdf, pageNum, slot, width) {
    if (slot.getAttribute('data-rendered') === '1') return Promise.resolve();
    slot.setAttribute('data-rendered', '1');

    return pdf.getPage(pageNum).then(function (page) {
      var unscaled = page.getViewport({ scale: 1 });
      var scale = width / unscaled.width;
      var viewport = page.getViewport({ scale: scale });
      var outputScale = Math.min(window.devicePixelRatio || 1, isAndroid() ? 1.75 : 2);
      var canvasW = viewport.width * outputScale;
      var canvasH = viewport.height * outputScale;
      if (canvasW > MAX_CANVAS || canvasH > MAX_CANVAS) {
        outputScale *= Math.min(MAX_CANVAS / canvasW, MAX_CANVAS / canvasH);
      }
      var canvas = document.createElement('canvas');
      canvas.className = 'qr-pdf__page';
      canvas.setAttribute('aria-label', 'Page ' + pageNum);
      var ctx = canvas.getContext('2d', { alpha: false });
      canvas.width = Math.floor(viewport.width * outputScale);
      canvas.height = Math.floor(viewport.height * outputScale);
      canvas.style.width = Math.floor(viewport.width) + 'px';
      canvas.style.height = Math.floor(viewport.height) + 'px';
      slot.innerHTML = '';
      slot.appendChild(canvas);
      var transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null;
      return page.render({
        canvasContext: ctx,
        viewport: viewport,
        transform: transform,
        intent: 'display'
      }).promise;
    });
  }
})();
